module.exports = __webpack_public_path__ + "media/images/6_help-834e9e4c69442095e448cc707c9bb8e3.jpg";